import { Box } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { AddTransfersFormValues } from './useForm'

export interface PaymentsOptionItem {
  value: number
  label: string
}
export interface AddTransfersToBulkPaymentFormProps {
  form: ReturnType<typeof useForm<AddTransfersFormValues>>
  paymentsOptions: PaymentsOptionItem[]
}

export const AddTransfersToBulkPaymentForm = ({
  form,
  paymentsOptions,
}: AddTransfersToBulkPaymentFormProps) => {
  return (
    <Box gap="s16">
      <SelectField
        mandatory
        none={i18n.t('banking.bulk_payment.forms.fields.payment.placeholder')}
        label={i18n.t('banking.bulk_payment.forms.fields.payment.label')}
        value={form.values.paymentId?.toString()}
        onChange={(value) => form.setFieldValue('paymentId', Number(value))}
        options={paymentsOptions}
      />
    </Box>
  )
}
